export default __webpack_public_path__ + "static/media/creative.af94119f.svg";